import { jsx as _jsx } from "react/jsx-runtime";
const LockedSvg = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10 2a4 4 0 00-4 4v2H5a1.5 1.5 0 00-1.5 1.5v7A1.5 1.5 0 005 18h10a1.5 1.5 0 001.5-1.5v-7A1.5 1.5 0 0015 8h-1V6a4 4 0 00-4-4zM7.5 6a2.5 2.5 0 015 0v2h-5V6zm-2.5 4v6.5h10V10H5z",
            fill: "currentColor"
        })
    });
export default LockedSvg;
